module.exports = __webpack_public_path__ + "static/media/gray_11.47ac78ef.jpg";